import { render } from "./deleteRequest.vue?vue&type=template&id=442f43c1&scoped=true"
import script from "./deleteRequest.vue?vue&type=script&lang=js"
export * from "./deleteRequest.vue?vue&type=script&lang=js"

import "./deleteRequest.vue?vue&type=style&index=0&id=442f43c1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-442f43c1"

export default script